module.exports = __webpack_public_path__ + "img/gold-orb.c5a5b749.svg";